// --- validators ---
const FORBIDDEN_REGEX =
  /["*^%={}\[\]\\`~<>!?]|[\p{Sc}]|[\p{Emoji_Presentation}\p{Extended_Pictographic}]|[^\p{ASCII}]/u;

const START_FORBIDDEN = /^[0/-]/;
const HAS_NUMBER = /\d/;

/**
 * Validate voucher value and return { valid, message }
 * @param {string} value
 * @param {string} label - e.g. invoiceLabels?.voucherName ("Invoice No", "Voucher No", etc.)
 */
export function CheckVoucherValid(value, label = "Voucher number") {
  const v = value ?? "";
  const trimmed = v.trim();

  if (trimmed === "") {
    return { valid: false, message: `${label} is required` };
  }
  if (FORBIDDEN_REGEX.test(v)) {
    return { valid: false, message: `${label} contains invalid characters` };
  }
  if (START_FORBIDDEN.test(v)) {
    return { valid: false, message: `${label} cannot start with 0, /, or -` };
  }
  if (!HAS_NUMBER.test(v)) {
    return { valid: false, message: `${label} must contain at least one digit` };
  }
  return { valid: true, message: "" };
}
